import { render, staticRenderFns } from "./ItemBarcodeCard.vue?vue&type=template&id=4d029897"
import script from "./ItemBarcodeCard.vue?vue&type=script&lang=js"
export * from "./ItemBarcodeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports